
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { DefaultItemAclResult, DefaultModelAclResult } from '@/store/acl/types';
import { ItemAclResult, ModelAclResult } from '@/store/acl/types';
import { ActionI18N } from '@/uikit';
import NButton from '@/uikit/buttons/NButton.vue';
import NDropdown from '@/uikit/dropdown/NDropdown.vue';
import NDropdownItem from '@/uikit/dropdown/NDropdownItem.vue';
import NTag from '@/uikit/tag/NTag.vue';
import MultisidebarHeaderActions from '@/components/multisidebar/MultisidebarHeaderActions.vue';

@Options({
  name: 'MultisidebarHeader',
  components: { MultisidebarHeaderActions, NButton, NDropdown, NDropdownItem, NTag },
  emits: ['action']
})
export default class MultisidebarHeader extends Vue {
  @Prop({ type: String, default: '' })
  readonly label!: string;

  @Prop({ type: String, default: '' })
  readonly tag!: string;

  @Prop({ type: String, default: '' })
  readonly subLabel!: string;

  @Prop({ type: Boolean, default: false })
  readonly changed!: boolean;

  @Prop({ type: Boolean, default: false, required: false })
  readonly disableActions!: boolean;

  @Prop({ type: Array, default: () => [] })
  readonly actions!: ActionI18N[];

  @Prop({ type: Boolean, default: false })
  readonly inactivated!: boolean;

  @Prop({ type: String, default: 'common.inactivated' })
  readonly i18nInactivatedLabel!: string;

  @Prop({ type: Object, default: () => ({ ...DefaultItemAclResult }) })
  readonly currentItemAcl!: ItemAclResult;

  @Prop({ type: Object, default: () => ({ ...DefaultModelAclResult }) })
  readonly modelAcl!: ModelAclResult;

  @Prop({ type: Boolean, default: true })
  readonly hasDeselect!: boolean;

  @Prop({ type: Boolean, default: true })
  readonly hasToggle!: boolean;

  @Prop({ type: String, default: 'msb-undefined' })
  readonly dataQa!: string;

  actionHandler(action: string) {
    this.$emit('action', action);
  }
}
